(function () {
  'use strict';

  angular.module('ringbaPortal').component('changelogParts', {
    bindings: {
      parts: '<',
      wide: '<'
    },
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/changelog/changelog-parts/changelog-parts.view.html'
  });
})();
